"use client";

import { HeroSectionProps } from "@/Templates/SectionsProps";
import { FC } from "react";
import GeneratedHeroSection from "../Components/GeneratedHeroSection";

const Hero: FC<HeroSectionProps> = (props) => {
  return <GeneratedHeroSection {...props} />;
};

export default Hero;
